import store from '../store/store.js'



export default (i) => {

    //call the mutation to reset state in survey module    
    store.commit('dash/CHANGE_MULTI_LOCATION', i)

    //calls the mutation to change location in dash module    
    store.commit('survey/RESET_SURVEY_STATE', i)

  }